import vendorDashboardAPI from '@/utils/api/vendorDashboard';
import { genericError } from '@/utils/alerts.service';
import { fileUpload } from '@/store/vendorDashboard/modules/fileUpload';
import router from '@/router/dashboard.js';

export const agencyDetailProfile = {
  namespaced: true,
  state: {
    partner: {},
    filters: [],
  },
  getters: {
    getTiers(state) {
      return state.tiers;
    },
    getFilters(state) {
      return state.filters;
    },
  },
  mutations: {
    setPartnerDetail(state, data) {
      state.partner = data;
    },
    addFilter(state, filter) {
      state.partner.filterOptions.push(filter);
    },
    removeFilter(state, index) {
      state.partner.filterOptions.splice(index, 1);
    },
    setFilters(state, filters) {
      state.filters = filters;
    },
    setAboutUs(state, value) {
      state.partner.aboutUs = value;
    },
    setStatus(state, value) {
      state.partner.status = value;
    },
    setFeatured(state, value) {
      state.partner.featured = value;
    },
    setTier(state, value) {
      state.partner.tier = value;
    },
    setBadge(state, value) {
      state.partner.badge = value;
    },
    setImage(state, payload) {
      state.partner[payload.field] = payload.uri || '';
    },
  },
  actions: {
    ...fileUpload.actions,

    async fetchPartnerDetail({ dispatch, commit }, id) {
      return vendorDashboardAPI
        .getPartner(id)
        .then(data => {
          commit('setPartnerDetail', data);

          return vendorDashboardAPI
            .getFilters(data.directory)
            .then(filterData => {
              commit('setFilters', filterData.results);
            })
            .catch(() => {
              dispatch('showUserMessage', { ...genericError }, { root: true });
            });
        })
        .catch(() => {
          dispatch('showUserMessage', { ...genericError }, { root: true });
        });
    },

    clearPartner({ commit }) {
      commit('setPartnerDetail', {});
    },

    async saveChanges({ commit, state }) {
      return new Promise((resolve, reject) => {
        const data = {
          ...state.partner,
          image: state.partner.renderImg || undefined,
          name: state.partner.renderName,
          website: state.partner.renderWebsite,
          aboutUs: state.partner.renderAboutUs,
        };
        return vendorDashboardAPI
          .savePartner(state.partner.id, data)
          .then(() => {
            commit('addSaveProgress', null, { root: true });
            resolve();
          })
          .catch(() => {
            reject();
          });
      });
    },

    async removeProfile({ dispatch }, id) {
      return vendorDashboardAPI
        .deletePartner(id)
        .then(() => {
          router.push({ name: 'Partners' });
        })
        .catch(() => {
          dispatch('showUserMessage', { ...genericError }, { root: true });
        });
    },

    updateFilters({ commit, state }, id) {
      for (let appliedFilter of state.partner.filterOptions) {
        if (appliedFilter === id) {
          return commit('removeFilter', id);
        }
      }
      return commit('addFilter', id);
    },

    handleCheckboxChange({ commit, state }, filter) {
      let add = true;
      let index = 0;

      state.partner.filterOptions.forEach((option, i) => {
        if (option === filter) {
          add = false;
          index = i;
        }
      });

      if (add) {
        commit('agencyProfiles/agencyDetail/markSectionDirty', 'profile', {
          root: true,
        });
        return commit('addFilter', filter);
      }

      commit('agencyProfiles/agencyDetail/markSectionDirty', 'profile', {
        root: true,
      });
      return commit('removeFilter', index);
    },

    handleDropdownChange({ commit, state, rootState }, payload) {
      const partnerFilters = state.partner.filterOptions;
      const dirFilters = rootState.vendorDashboard.filters;
      let changedFilter = undefined;
      let dirty = false;

      for (let filter of dirFilters) {
        if (filter.id === payload.filter) {
          changedFilter = filter;
        }
      }

      for (const [i, v] of partnerFilters.entries()) {
        for (let option of changedFilter.filterOptions) {
          if (v === option.id) {
            dirty = true;
            commit('removeFilter', i);
          }
        }
      }

      if (payload.option) {
        dirty = true;
        commit('addFilter', payload.option);
      }

      if (dirty) {
        commit('agencyProfiles/agencyDetail/markSectionDirty', 'profile', {
          root: true,
        });
      }
    },

    handleAboutUsChange({ commit }, data) {
      commit('agencyProfiles/agencyDetail/markSectionDirty', 'profile', {
        root: true,
      });
      commit('setAboutUs', data.value);
    },

    handleStatusChange({ commit }, data) {
      commit('agencyProfiles/agencyDetail/markSectionDirty', 'profile', {
        root: true,
      });
      commit('setStatus', data.value);
    },

    handleFeaturedChange({ commit }, data) {
      commit('agencyProfiles/agencyDetail/markSectionDirty', 'profile', {
        root: true,
      });
      commit('setFeatured', data.value);
    },

    handleTierChange({ commit }, data) {
      commit('agencyProfiles/agencyDetail/markSectionDirty', 'profile', {
        root: true,
      });
      commit('setTier', data.value);
    },

    handleBadgeChange({ commit }, data) {
      commit('agencyProfiles/agencyDetail/markSectionDirty', 'profile', {
        root: true,
      });
      commit('setBadge', data.value);
    },
  },
};
